@if (request) {
    <div class="request-view">
        <div class="request-view__detail main-content" [ngClass]="{ 'right-panel-closed': !isLogSidebarOpened }">
            <div class="row border-bottom px-3 pb-3 justify-content-between">
                <button
                    type="button"
                    (click)="addResultFileTask(request.id)"
                    class="btn btn-primary m-1 w-auto d-flex align-items-center">
                    <i class="fa-solid fa-unlock"></i>
                    {{ 'Request new file' | translate }}
                </button>
                <button
                    type="button"
                    (click)="
                        updateRequestStatus(
                            request.id,
                            request.status === personalDataRequestStatusEnum.archived ? false : true
                        )
                    "
                    [disabled]="isArchiving"
                    class="btn btn-default right m-1 w-auto">
                    <i class="fa fa-archive icon-status icon-status_archive" aria-hidden="true"></i>
                    @if (request.status === personalDataRequestStatusEnum.archived) {
                        <span>
                            {{ 'Unarchive' | translate }}
                        </span>
                    }
                    @if (request.status !== personalDataRequestStatusEnum.archived) {
                        <span>
                            {{ 'Archive' | translate }}
                        </span>
                    }
                </button>
                <button type="button" (click)="toggleLogSidebar()" class="btn btn-default right m-1 w-auto">Log</button>
            </div>
            <div class="mt-3">
                <button type="button" (click)="closeRequestView()" class="mb-2 btn btn-link btn_close-request-view">
                    {{ 'Back' | translate }}
                </button>
                <h2 class="request-title">{{ 'Request' | translate }} #{{ request.id }}</h2>
            </div>
            <dl class="row top30">
                <dt class="col-sm-3">
                    {{ 'Time created' | translate }}
                </dt>
                <dd class="col-sm-9">
                    {{ request.creationTime | date: 'dd.MM.yyyy HH:mm' }}
                </dd>
                <dt class="col-sm-3">
                    {{ 'Created by' | translate }}
                </dt>
                <dd class="col-sm-9">
                    {{ request.createdBy.name || request.createdBy.email }}
                </dd>
                <dt class="col-sm-3">
                    {{ 'Notes' | translate }}
                </dt>
                <dd class="col-sm-9">
                    {{ request.requestedBy }}
                </dd>
                <dt class="col-sm-3">
                    {{ 'Internal reference' | translate }}
                </dt>
                <dd class="col-sm-9">
                    {{ request.internalReference }}
                </dd>
                <dt class="col-sm-3">
                    {{ 'Request status' | translate }}
                </dt>
                <dd class="col-sm-9">
                    {{ request.status | personalDataRequestStatus }}
                </dd>
                <dt class="col-sm-3">
                    {{ 'Link URL' | translate }}
                </dt>
                <dd class="col-sm-9">
                    {{ request.accessToken.url }}
                    <button
                        class="btn fa fa-copy"
                        aria-hidden="true"
                        ngxClipboard
                        [cbContent]="request.accessToken.url"
                        (click)="showClipboardNotification()"
                        [tooltip]="'Copy' | translate"></button>
                </dd>
                <dt class="col-sm-3">
                    {{ 'Link status' | translate }}
                </dt>
                <dd class="col-sm-9">
                    {{ request.accessToken.isExpired ? ('Expired' | translate) : ('Active' | translate) }}
                </dd>
                <dt class="col-sm-3">
                    {{ 'Files' | translate }}
                </dt>
                <dd class="col-sm-9 dd_table">
                    @if (request.resultFiles.length >= 1) {
                        <table class="table table-striped table-bordered table-sm" style="max-width: 600px">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        {{ 'Id' | translate }}
                                    </th>
                                    <th scope="col">
                                        {{ 'Time created' | translate }}
                                    </th>
                                    <th scope="col">
                                        {{ 'Status' | translate }}
                                    </th>
                                    <th scope="col">
                                        {{ 'Requested By' | translate }}
                                    </th>
                                    <th scope="col">{{ 'PDF file' | translate }}</th>
                                    <th scope="col">{{ 'HTML file' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (file of request.resultFiles; track file) {
                                    <tr>
                                        <td>{{ file.id }}</td>
                                        <td>{{ file.creationTime | date: 'dd.MM.yyyy HH:mm' }}</td>
                                        <td>{{ file.status | requestFileStatus }}</td>
                                        <td>{{ file.requestedBy.name }}</td>
                                        <td style="text-align: center; vertical-align: middle">
                                            @if (file.status === requestFileStatusEnum.available) {
                                                <a class="file-link" href="{{ file.url }}">
                                                    <i class="fa-solid fa-file-lines"></i>
                                                </a>
                                            }
                                        </td>
                                        <td style="text-align: center; vertical-align: middle">
                                            @if (
                                                file.status === requestFileStatusEnum.available &&
                                                file.htmlFileAvailable
                                            ) {
                                                <a (click)="getPreviewFile(request.id, file.id)" class="file-link">
                                                    <i class="fa-solid fa-file-code"></i>
                                                </a>
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </dd>
                <dt class="col-sm-3">
                    {{ 'Contact email' | translate }}
                </dt>
                <dd class="col-sm-9">
                    {{ request.contactAddress.email }}
                </dd>
            </dl>
        </div>
        <div class="request-view__log right-panel" [ngClass]="{ closed: !isLogSidebarOpened }">
            <button type="button" class="btn btn-back" (click)="isLogSidebarOpened = !isLogSidebarOpened">
                <svg
                    class="back-icon"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="492px"
                    height="492px"
                    viewBox="0 0 492 492"
                    style="enable-background: new 0 0 492 492"
                    xml:space="preserve"
                    fill="#a3acb5">
                    <path
                        d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
                        C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
                        c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
                        l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z" />
                </svg>
                {{ 'Back' | translate }}
            </button>
            <app-request-log></app-request-log>
        </div>
    </div>
}
